// extracted by mini-css-extract-plugin
export default {"section":"HomeTemplate_section__hdy4j","sectionTitle":"HomeTemplate_sectionTitle__Vu49C"};